import { Check, Star } from "lucide-react";

export default function DeliveredCard({ isPickup, restaurantId, orderId, tt }) {
  return (
    <div className="bg-emerald-50 border-2 border-emerald-200 rounded-2xl p-6 text-center" data-testid="delivered-card">
      <div className="w-16 h-16 rounded-full bg-emerald-500 flex items-center justify-center mx-auto mb-3">
        <Check className="w-8 h-8 text-white" />
      </div>
      <h2 className="text-xl font-bold text-emerald-800 mb-1">
        {isPickup ? "¡Pedido Recogido!" : tt("orderDelivered")}
      </h2>
      <p className="text-emerald-600">
        {isPickup ? "¡Gracias! Esperamos que lo disfrutes 😋" : tt("thanksForBuying")}
      </p>
      <a
        href={`/review/${restaurantId}/${orderId}`}
        className="inline-block mt-4 bg-yellow-400 hover:bg-yellow-500 text-yellow-900 font-medium px-6 py-3 rounded-xl transition-colors"
        data-testid="rate-order-btn"
      >
        <div className="flex items-center gap-2">
          {[1, 2, 3, 4, 5].map(s => (
            <Star key={s} className="w-5 h-5" fill="none" />
          ))}
        </div>
        <span className="text-sm mt-1 block">{tt("rateExperience")}</span>
      </a>
    </div>
  );
}
